module.exports = __webpack_public_path__ + "a039bff15da23972d9583a35b5af598c.svg";